import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './Post.css';
import publicAxios from '../../utils/axios/publicAxios';
import moment from 'moment';
import IMAGEALT from '../../assets/images/igboezenorthlga.png';
import { Circles } from 'react-loader-spinner';

const embedYouTubeLinks = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const anchors = doc.querySelectorAll('a[href*="youtube.com/watch"], a[href*="youtu.be/"]');

    anchors.forEach((a) => {
        let videoId = null;
        const url = new URL(a.href);

        if (url.hostname.includes('youtu.be')) {
            videoId = url.pathname.slice(1);
        } else {
            videoId = url.searchParams.get('v');
        }

        if (videoId) {
            const iframe = document.createElement('iframe');
            iframe.width = '100%';
            iframe.height = '400';
            iframe.src = `https://www.youtube.com/embed/${videoId}`;
            iframe.frameBorder = '0';
            iframe.allow =
                'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;

            a.replaceWith(iframe);
        }
    });

    return doc.body.innerHTML;
};

const Post = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await publicAxios.get(`/public/post/${id}`);
                setPost(response.data.post);
            } catch (error) {
                console.error('Error fetching post', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [id]);

    if (loading) {
        return (
            <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '500px', color: 'gray' }}>
                <Circles height="50" width="50" color="#008751" ariaLabel="loading" />
                <h2>Loading Post...</h2>
            </div>
        );
    }

    if (!post) return <div className="post-error">Post not found.</div>;

    return (
        <div className="post">
            <div className="post-wrapper">
                <div className="post-header">
                    <h1>{post.title}</h1>
                    {post.imageUrl ? (
                        <img src={post.imageUrl} alt={post.title} className="post-image" loading='lazy' />
                    ) : (
                        <div>
                            <img src={IMAGEALT} alt={post.title} className="posts-image" loading='lazy' />
                        </div>
                    )}
                    <div className="post-meta">
                        <p>Posted By: <strong>{post.createdBy?.firstname} {post.createdBy?.lastname}</strong></p>
                        <p>On: <strong>{moment(post.createdAt).format('MMMM DD, YYYY')}</strong></p>
                        {/* {post.updatedAt && (<span>Last Edited: <strong>{moment(post.updatedAt).format('MMMM DD, YYYY')}</strong></span>)} */}
                    </div>
                </div>

                <div className="post-content"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(embedYouTubeLinks(post.content), {
                            ADD_TAGS: ['iframe'],
                            ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height'],
                        }),
                    }}
                ></div>


                <div className="post-actions">
                    <button onClick={() => navigate('/posts')}>Back to Posts</button>
                </div>
            </div>
        </div>
    );
};

export default Post;